import checkByID from './checkByID';

/**
 * Get Category
 */
export default function () {
    let category = $('.js-services-category');
    let categoryId;

    category.on('click', function () {
        if (!$(this).hasClass('active')) {
            // Remove all search inputs
            $('.js-services--search').val('');

            category.removeClass('active');
            $(this).toggleClass('active');
            categoryId = $(this).data('id');

            checkByID(categoryId);
        } else {
            $(this).removeClass('active');
        }
    });
}
